// extracted by mini-css-extract-plugin
module.exports = {"card":"PlanCard_card__2vfDY"};